export default __webpack_public_path__ + "assets/images/CT-Coronary-Arteries-2.png";